import React, { useState } from "react";
import "./SizeGuidePage.css";

const SizeGuide = () => {
  const [selectedCategory, setSelectedCategory] = useState("tops");

  // Size data for different categories
  const sizeData = {
    tops: [
      {
        age: "0-3 Months",
        size: "NB",
        chest: '16"',
        length: '14"',
        shoulder: '7"',
      },
      {
        age: "3-6 Months",
        size: "0-3M",
        chest: '17"',
        length: '15"',
        shoulder: '7.5"',
      },
      {
        age: "6-12 Months",
        size: "6-9M",
        chest: '18"',
        length: '16"',
        shoulder: '8"',
      },
      {
        age: "12-18 Months",
        size: "12-18M",
        chest: '19"',
        length: '17"',
        shoulder: '8.5"',
      },
      {
        age: "18-24 Months",
        size: "18-24M",
        chest: '20"',
        length: '18"',
        shoulder: '9"',
      },
      {
        age: "2-3 Years",
        size: "2-3Y",
        chest: '21"',
        length: '19"',
        shoulder: '9.5"',
      },
    ],
    bottoms: [
      {
        age: "0-3 Months",
        size: "NB",
        waist: '16"',
        length: '12"',
        inseam: '5"',
      },
      {
        age: "3-6 Months",
        size: "0-3M",
        waist: '17"',
        length: '13"',
        inseam: '6"',
      },
      {
        age: "6-12 Months",
        size: "6-9M",
        waist: '18"',
        length: '14"',
        inseam: '7"',
      },
      {
        age: "12-18 Months",
        size: "12-18M",
        waist: '19"',
        length: '15"',
        inseam: '8"',
      },
      {
        age: "18-24 Months",
        size: "18-24M",
        waist: '20"',
        length: '16"',
        inseam: '9"',
      },
      {
        age: "2-3 Years",
        size: "2-3Y",
        waist: '21"',
        length: '17"',
        inseam: '10"',
      },
    ],
    dresses: [
      {
        age: "0-3 Months",
        size: "NB",
        chest: '16"',
        length: '16"',
        shoulder: '7"',
      },
      {
        age: "3-6 Months",
        size: "0-3M",
        chest: '17"',
        length: '17"',
        shoulder: '7.5"',
      },
      {
        age: "6-12 Months",
        size: "6-9M",
        chest: '18"',
        length: '18"',
        shoulder: '8"',
      },
      {
        age: "12-18 Months",
        size: "12-18M",
        chest: '19"',
        length: '19"',
        shoulder: '8.5"',
      },
      {
        age: "18-24 Months",
        size: "18-24M",
        chest: '20"',
        length: '20"',
        shoulder: '9"',
      },
      {
        age: "2-3 Years",
        size: "2-3Y",
        chest: '21"',
        length: '21"',
        shoulder: '9.5"',
      },
    ],
  };

  const categories = [
    { id: "tops", name: "Tops & Shirts", icon: "👕" },
    { id: "bottoms", name: "Bottoms & Pants", icon: "👖" },
    { id: "dresses", name: "Dresses", icon: "👗" },
  ];

  return (
    <div className="sg-page">
      <div className="sg-container">
        {/* Header */}
        <div className="sg-header">
          <div className="sg-header-content">
            <h1 className="sg-title">Size Guide</h1>
            <p className="sg-subtitle">
              Find the perfect fit for your little one (0-3 Years)
            </p>
          </div>
          <div className="sg-baby-illustration">
            <span className="sg-baby-emoji">👶</span>
          </div>
        </div>

        {/* Category Tabs */}
        <div className="sg-category-tabs">
          {categories.map((category) => (
            <button
              key={category.id}
              className={`sg-tab ${
                selectedCategory === category.id ? "sg-tab-active" : ""
              }`}
              onClick={() => setSelectedCategory(category.id)}
            >
              <span className="sg-tab-icon">{category.icon}</span>
              <span className="sg-tab-text">{category.name}</span>
            </button>
          ))}
        </div>

        {/* Size Chart */}
        <div className="sg-chart-section">
          <div className="sg-chart-wrapper">
            <div className="sg-table-container">
              <table className="sg-table">
                <thead className="sg-table-head">
                  <tr className="sg-table-row">
                    <th className="sg-table-header">Age</th>
                    <th className="sg-table-header">Size</th>
                    {selectedCategory === "tops" && (
                      <>
                        <th className="sg-table-header">Chest</th>
                        <th className="sg-table-header">Length</th>
                        <th className="sg-table-header">Shoulder</th>
                      </>
                    )}
                    {selectedCategory === "bottoms" && (
                      <>
                        <th className="sg-table-header">Waist</th>
                        <th className="sg-table-header">Length</th>
                        <th className="sg-table-header">Inseam</th>
                      </>
                    )}
                    {selectedCategory === "dresses" && (
                      <>
                        <th className="sg-table-header">Chest</th>
                        <th className="sg-table-header">Length</th>
                        <th className="sg-table-header">Shoulder</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody className="sg-table-body">
                  {sizeData[selectedCategory].map((row, index) => (
                    <tr key={index} className="sg-table-row sg-table-data-row">
                      <td className="sg-table-data sg-age-cell">{row.age}</td>
                      <td className="sg-table-data sg-size-cell">{row.size}</td>
                      {selectedCategory === "tops" && (
                        <>
                          <td className="sg-table-data">{row.chest}</td>
                          <td className="sg-table-data">{row.length}</td>
                          <td className="sg-table-data">{row.shoulder}</td>
                        </>
                      )}
                      {selectedCategory === "bottoms" && (
                        <>
                          <td className="sg-table-data">{row.waist}</td>
                          <td className="sg-table-data">{row.length}</td>
                          <td className="sg-table-data">{row.inseam}</td>
                        </>
                      )}
                      {selectedCategory === "dresses" && (
                        <>
                          <td className="sg-table-data">{row.chest}</td>
                          <td className="sg-table-data">{row.length}</td>
                          <td className="sg-table-data">{row.shoulder}</td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* How to Measure Section */}
        <div className="sg-measure-section">
          <h2 className="sg-measure-title">
            <span className="sg-measure-icon">📏</span>
            How to Measure Your Baby
          </h2>

          <div className="sg-measure-grid">
            <div className="sg-measure-card sg-card-coral">
              <div className="sg-card-icon">📐</div>
              <h3 className="sg-card-title">Chest</h3>
              <p className="sg-card-desc">
                Measure around the fullest part of the chest, keeping the tape
                parallel to the floor.
              </p>
            </div>

            <div className="sg-measure-card sg-card-blue">
              <div className="sg-card-icon">📏</div>
              <h3 className="sg-card-title">Length</h3>
              <p className="sg-card-desc">
                Measure from the highest point of the shoulder down to the
                desired length.
              </p>
            </div>

            <div className="sg-measure-card sg-card-orange">
              <div className="sg-card-icon">✂️</div>
              <h3 className="sg-card-title">Waist</h3>
              <p className="sg-card-desc">
                Measure around the natural waistline, allowing the tape to sit
                comfortably.
              </p>
            </div>

            <div className="sg-measure-card sg-card-navy">
              <div className="sg-card-icon">🧵</div>
              <h3 className="sg-card-title">Inseam</h3>
              <p className="sg-card-desc">
                Measure from the crotch seam down to the bottom hem of the leg.
              </p>
            </div>
          </div>
        </div>

        {/* Tips Section */}
        <div className="sg-tips-section">
          <h2 className="sg-tips-title">
            <span className="sg-tips-icon">💡</span>
            Helpful Tips
          </h2>

          <div className="sg-tips-grid">
            <div className="sg-tip-card">
              <div className="sg-tip-number">1</div>
              <div className="sg-tip-content">
                <h4 className="sg-tip-heading">Room to Grow</h4>
                <p className="sg-tip-text">
                  Babies grow quickly! Consider sizing up if your child is
                  between sizes.
                </p>
              </div>
            </div>

            <div className="sg-tip-card">
              <div className="sg-tip-number">2</div>
              <div className="sg-tip-content">
                <h4 className="sg-tip-heading">Comfort First</h4>
                <p className="sg-tip-text">
                  Choose soft, breathable fabrics that allow easy movement for
                  active babies.
                </p>
              </div>
            </div>

            <div className="sg-tip-card">
              <div className="sg-tip-number">3</div>
              <div className="sg-tip-content">
                <h4 className="sg-tip-heading">Check Product Details</h4>
                <p className="sg-tip-text">
                  Each product page includes specific measurements for that
                  item.
                </p>
              </div>
            </div>

            <div className="sg-tip-card">
              <div className="sg-tip-number">4</div>
              <div className="sg-tip-content">
                <h4 className="sg-tip-heading">Easy Diaper Changes</h4>
                <p className="sg-tip-text">
                  Look for snap buttons or elastic waistbands for convenient
                  diaper changes.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="sg-faq-section">
          <h2 className="sg-faq-title">
            <span className="sg-faq-icon">❓</span>
            Frequently Asked Questions
          </h2>

          <div className="sg-faq-list">
            <div className="sg-faq-item">
              <h4 className="sg-faq-question">
                What if my baby is between sizes?
              </h4>
              <p className="sg-faq-answer">
                We recommend choosing the larger size to allow room for growth
                and ensure comfort. Babies grow quickly, especially in the first
                year!
              </p>
            </div>

            <div className="sg-faq-item">
              <h4 className="sg-faq-question">
                Do your sizes run small or large?
              </h4>
              <p className="sg-faq-answer">
                Our sizes are designed to fit true to age. However, every baby
                is unique. Check the specific measurements in the size chart
                above.
              </p>
            </div>

            <div className="sg-faq-item">
              <h4 className="sg-faq-question">
                Can I exchange if the size doesn't fit?
              </h4>
              <p className="sg-faq-answer">
                Yes! You can initiate a return within 3 days of delivery if the
                item is unused and in original packaging. See our Return Policy
                for details.
              </p>
            </div>

            <div className="sg-faq-item">
              <h4 className="sg-faq-question">
                How often should I measure my baby?
              </h4>
              <p className="sg-faq-answer">
                We recommend measuring every 2-3 months during the first year,
                as babies grow rapidly. After 12 months, every 3-4 months is
                sufficient.
              </p>
            </div>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="sg-contact-cta">
          <div className="sg-cta-content">
            <h3 className="sg-cta-title">Still Need Help?</h3>
            <p className="sg-cta-text">
              Our customer care team is here to help you find the perfect fit!
            </p>
            <div className="sg-cta-buttons">
              <a
                href="mailto:support@kittynmice.com"
                className="sg-cta-btn sg-btn-primary"
              >
                📧 Email Us
              </a>
              <a
                href="tel:+911234567890"
                className="sg-cta-btn sg-btn-secondary"
              >
                📞 Call Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SizeGuide;
